import { defaultMenuItemRenderer, defaultNoMatchMenuItemRenderer } from './select-components';
import { MenuItemRenderer, NoMatchesItemRenderer } from './select.types';
import { MenuItem } from '../filter-combo-box/filter-combo-box.types';

const trimValue = (value: string | number | readonly string[] | undefined) => (value?.toString() ?? '').trim();

const getMenuItemRenderer = (suppliedFn: MenuItemRenderer | undefined) => suppliedFn ?? defaultMenuItemRenderer;

const getNoMatchItemRenderer = (suppliedFn: NoMatchesItemRenderer | undefined) =>
  suppliedFn ?? defaultNoMatchMenuItemRenderer;

const computeNewValue = (searchTerm: string | undefined, value: string | undefined) => searchTerm ?? value ?? '';

const menuItemsSorter = <T extends MenuItem>(a: T, b: T) => a.label.localeCompare(b.label);

export { computeNewValue, getMenuItemRenderer, getNoMatchItemRenderer, menuItemsSorter, trimValue };
